import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

import { ManagerGuard } from './auth/guards/manager.guard';
import { UserGuard } from './auth/guards/user.guard';
import { LogoutComponent } from './components/logout/logout.component';
import { AppPermissions } from './consts/app-permissions';
import { HelpPageTags } from './help/help-page-tags-enum';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
    data: {
      help: HelpPageTags.Dashboard,
    },
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, ManagerGuard],
  },
  {
    path: 'manager',
    loadChildren: () =>
      import('./manager/manager.module').then((m) => m.ManagerModule),
    canActivate: [AuthGuard, ManagerGuard],
  },
  {
    path: 'sales',
    loadChildren: () =>
      import('./sales/sales.module').then((m) => m.SalesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'purchases',
    loadChildren: () =>
      import('./purchases/purchases.module').then((m) => m.PurchasesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'payments',
    loadChildren: () =>
      import('./payments/payments.module').then((m) => m.PaymentsModule),
    canActivate: [AuthGuard, UserGuard],
    data: {
      help: HelpPageTags.PaymentsQuickStartGuide,
      permission: AppPermissions.paymentsAccess,
    },
  },
  {
    path: 'purchasing-accounts',
    loadChildren: () =>
      import('./purchasing-accounts/purchasing-accounts.module').then(
        (m) => m.PurchasingAccountsModule
      ),
    canActivate: [AuthGuard, UserGuard],
    data: { permission: AppPermissions.poAccountsAccess },
  },
  {
    path: 'inventory',
    loadChildren: () =>
      import('./inventory/inventory.module').then((m) => m.InventoryModule),
    canActivate: [AuthGuard],
    data: {
      help: HelpPageTags.Inventory,
    },
  },
  {
    path: 'purchasing-accounts-beta',
    loadChildren: () =>
      import('./purchasing-accounts-beta/purchasing-accounts-beta.module').then(
        (m) => m.ExternalAccountsModule
      ),
  },
  {
    path: 'integrations',
    loadChildren: () =>
      import('./integrations/integrations.module').then(
        (m) => m.IntegrationsModule
      ),
    canActivate: [AuthGuard, ManagerGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
